const prefix = 'profile-footer';

export const i18n = {
    signOut: {
        id: `${prefix}.signOut`,
        defaultMessage: 'Sign out',
    },
} as const;
